module.exports = __webpack_public_path__ + "static/media/facebook_icon.927b76a2.svg";